export default __webpack_public_path__ + "static/gamerize-3-b-cc030871e886b856bd98fb755829a4cf.webp";